import useApiMutation from './useApiMutation';

function useJoinResidenceMutation(code, options) {
  return useApiMutation('post', `/v1/join/${code}`, options);
}

export default useJoinResidenceMutation;
